// Interface

import util from '@/utils/classToObject'
import { IFleetState } from './state'


export class FleetGetter {  
 
  
  public currentDetailFleet(state:IFleetState) {
      return state.currentDetailFleet
  }
  
  public filterFleet(state:IFleetState) {
      return state.filterFleet
  }
    
  public detailFleets(state:IFleetState) {
      return state.detailFleets
  }   

   public isFleetFormationParameterVisible(state:IFleetState) {
      return  state.currentDetailFleet.tabsleft.selected.indexOf("FleetDetailParameterFormation") == 0 ||
              state.currentDetailFleet.tabsright.selected.indexOf("FleetDetailParameterFormation") == 0
    }   

    public isFleetFormationParameterOpen(state:IFleetState) {        
      return  state.currentDetailFleet.tabsleft.tabs.some((t) => t.cmp == "FleetDetailParameterFormation") ||
              state.currentDetailFleet.tabsright.tabs.some((t) => t.cmp == "FleetDetailParameterFormation") 
    }   

    public isFleetMissionPlanModuleOpen(state:IFleetState) {        
      return  state.currentDetailFleet.tabsleft.tabs.some((t) => t.cmp == "FleetDetailMissionPlan") ||
              state.currentDetailFleet.tabsright.tabs.some((t) => t.cmp == "FleetDetailMissionPlan") 
    }   

}

export default util.classToObject(FleetGetter)